// 考勤规则
<template>
  <div class="punch">
    <div class="searchRow">
      <!-- <el-input class="tableSearch" v-model="searchInfo" placeholder="规则名称"></el-input> -->
      <div class="min-width:100px"></div>
      <div class="btnCol">
        <!-- <el-button class="search" @click="handleSearch">查询</el-button> -->
        <el-button class="creat" style="background-color:#40A0F2;" @click="handleAddClick">新建</el-button>
      </div>
    </div>
    <el-table
      :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
      :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
      :data="tableData"
      stripe
      height="calc(100% - 68px - 20px)"
      style="width: 100%; margin-top:20px"
    >
      <!-- 考勤管理员 -->
      <el-table-column
        prop="clockin_user_names"
        :show-overflow-tooltip="true"
        align="center"
        label="考勤管理员"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.clockin_user_names">{{scope.row.clockin_user_names}}</span>
          <span v-else>{{'暂无设置'}}</span>
        </template>
      </el-table-column>
      <!-- 请假审批人 -->
      <el-table-column
        prop="leave_user_names"
        :show-overflow-tooltip="true"
        align="center"
        label="请假审批人"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.leave_user_names">{{scope.row.leave_user_names}}</span>
          <span v-else>{{'暂无设置'}}</span>
        </template>
      </el-table-column>
      <!-- 考勤规则 -->
      <el-table-column prop="rule_name" :show-overflow-tooltip="true" align="center" label="考勤规则">
        <template slot-scope="scope">
          <span v-if="scope.row.rule_name">{{scope.row.rule_name}}</span>
          <span v-else>{{'暂无设置'}}</span>
        </template>
      </el-table-column>

      <!-- 操作 -->
      <el-table-column width="250" :show-overflow-tooltip="true" align="center" label="操作">
        <template slot-scope="scope">
          <el-button @click="handleEditClick(scope.row)" class="tableBtn">编辑</el-button>
          <!-- <el-button
            @click="handleRemove(scope.row)"
            class="tableBtn"
            style="border-color: #999999;color: #666666;"
          >删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible.sync="dialogVisible"
      width="50%"
      class="checkDia"
      :before-close="handleClose"
      @close="handleClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">{{'新增规则'}}</span>
      </div>
      <div class="diaContainer">
        <el-form ref="form" :model="addFormData" label-position="left" label-width="150px">
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 考勤管理员 -->
            <el-form-item label="考勤管理员">
              <my-transfer
                v-if="isSelectShow"
                :selectedId="addFormData.clockin_user_ids"
                :showFullSelectedText="true"
                style="width:100%"
                @my-transfer-change="transferChange1"
              ></my-transfer>
            </el-form-item>
            <!-- 请假审批人 -->
            <el-form-item label="请假审批人">
              <my-transfer
                v-if="isSelectShow"
                :selectedId="addFormData.leave_user_ids"
                :showFullSelectedText="true"
                style="width:100%"
                @my-transfer-change="transferChange2"
              ></my-transfer>
            </el-form-item>
            <!-- 非考勤组人员 -->
            <el-form-item label="非考勤组人员">
              <my-transfer
                v-if="isSelectShow"
                :selectedId="addFormData.clockin_out_user_ids"
                :showFullSelectedText="true"
                style="width:100%"
                @my-transfer-change="transferChange3"
              ></my-transfer>
            </el-form-item>
            <!-- 考勤规则 -->
            <el-form-item label="考勤规则">
              <el-select clearable v-model="addFormData.work_shift_id" placeholder="请选择">
                <el-option
                  v-for="item in rulesList"
                  :key="item.id"
                  :label="item.rule_name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <!-- 报销新增按钮 -->
          <el-button style="background-color: #ccc;" @click="dialogVisible=false">取消</el-button>
          <el-button type="primary" v-if="!editId" @click="addSubmit">提 交</el-button>
          <el-button type="primary" v-if="editId" @click="editSubmit">编 辑</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import OneSelected from '../../../components/OneSelected'
import MyTransfer from '../../../components/MyTransfer'

export default {
  data() {
    return {
      tiemID: null,
      timeDou: 100,
      checkName: '',
      searchInfo: '',
      searchUserId: '',
      searchClass: '',
      searchMounth: '',
      classList: [],
      tableData: [],
      tableData2: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      isSelectShow: false,
      statusShow: '',
      addFormData: {
        clockin_user_ids: [],
        leave_user_ids: [],
        work_shift_id: '',
        clockin_out_user_ids: [],
      },
      startTime: '',
      endTime: '',
      editId: '',
      rulesList: [],
    }
  },
  components: {
    OneSelected,
    MyTransfer,
  },
  methods: {
    handleSearch() {
      this.currentPage = 1
      this.getMounthList()
    },
    // *点击删除
    async handleRemove(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/ClockInSet/rules_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getMounthList()
      }
    },
    // 点击编辑
    async handleEditClick(row) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/ClockInSet/clockin_administrator_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      const result = res.datas.data
      this.addFormData.clockin_user_ids = result.clockin_user_ids.split(',')
      this.addFormData.leave_user_ids = result.leave_user_ids.split(',')
      this.addFormData.clockin_out_user_ids =
        result.clockin_out_user_ids.split(',')
      this.addFormData.work_shift_id = result.work_shift_id
      this.dialogVisible = true
      this.isSelectShow = true
    },
    // *编辑提交
    async editSubmit() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)

      param.append(
        'clockin_user_ids',
        this.addFormData.clockin_user_ids.join(',')
      )
      param.append('leave_user_ids', this.addFormData.leave_user_ids.join(','))
      param.append('work_shift_id', this.addFormData.work_shift_id)
      param.append(
        'clockin_out_user_ids',
        this.addFormData.clockin_out_user_ids.join(',')
      )

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/ClockInSet/clockin_administrator_add',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.dialogVisible = false
      this.getMounthList()
    },
    // 点击新增
    handleAddClick() {
      this.isSelectShow = true
      this.dialogVisible = true
    },
    // *新增提交
    async addSubmit() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)

      param.append(
        'clockin_user_ids',
        this.addFormData.clockin_user_ids.join(',')
      )
      param.append('leave_user_ids', this.addFormData.leave_user_ids.join(','))
      param.append('work_shift_id', this.addFormData.work_shift_id)
      param.append(
        'clockin_out_user_ids',
        this.addFormData.clockin_out_user_ids.join(',')
      )

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/ClockInSet/clockin_administrator_add',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.dialogVisible = false
      this.getMounthList()
    },
    // *获取列表
    async getMounthList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/ClockInSet/clockin_administrator_list',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.tableData = [res.datas.data]
      // this.total = parseInt(res.datas.count)
      // this.isAdmin1 = res.datas.admin_state
      console.log('考勤规则', this.tableData)
    },
    transferChange1(data, index) {
      this.addFormData.clockin_user_ids = data
      this.addFormData.clockin_user_ids = this.addFormData.clockin_user_ids.map(
        (item) => item.id
      )

      // this.addFormData.clockin_user_ids = ''

      // data.forEach((item) => {
      //   this.addFormData.clockin_user_ids += item.id + ','
      // })
      // this.addFormData.clockin_user_ids =
      //   this.addFormData.clockin_user_ids.substring(
      //     0,
      //     this.addFormData.clockin_user_ids.length - 1
      //   )
      console.log(
        'this.addFormData.clockin_user_ids',
        this.addFormData.clockin_user_ids
      )
    },
    transferChange2(data, index) {
      this.addFormData.leave_user_ids = data
      this.addFormData.leave_user_ids = this.addFormData.leave_user_ids.map(
        (item) => item.id
      )
      // this.addFormData.leave_user_ids = ''

      // data.forEach((item) => {
      //   this.addFormData.leave_user_ids += item.id + ','
      // })
      // this.addFormData.leave_user_ids =
      //   this.addFormData.leave_user_ids.substring(
      //     0,
      //     this.addFormData.leave_user_ids.length - 1
      //   )
      console.log(
        'this.addFormData.leave_user_ids',
        this.addFormData.leave_user_ids
      )
    },
    transferChange3(data, index) {
      this.addFormData.clockin_out_user_ids = data
      this.addFormData.clockin_out_user_ids =
        this.addFormData.clockin_out_user_ids.map((item) => item.id)
      // this.addFormData.clockin_out_user_ids = ''

      // data.forEach((item) => {
      //   this.addFormData.clockin_out_user_ids += item.id + ','
      // })
      // this.addFormData.clockin_out_user_ids =
      //   this.addFormData.clockin_out_user_ids.substring(
      //     0,
      //     this.addFormData.clockin_out_user_ids.length - 1
      //   )
      console.log(
        'this.addFormData.clockin_out_user_ids',
        this.addFormData.clockin_out_user_ids
      )
    },
    // 获取考勤规则列表
    async getRulesList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)

      param.append('department_id', this.searchClass)
      param.append('user_id', this.searchUserId)
      param.append('month', this.searchMounth)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/ClockInSet/rules_list',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.rulesList = res.datas.data
      // this.isAdmin1 = res.datas.admin_state
      console.log('考勤规则', this.tableData)
    },
    handleSearchPeopleChange(data) {
      console.log('组件传过来的搜索', data)
      this.searchUserId = data
    },
    handleSizeChange() {
      this.pageSize = val
      this.getMounthList()
    },
    handleCurrentChange() {
      this.currentUserPage = val
      this.currentPage()
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    handleClosed() {
      this.addFormData.clockin_user_ids = []
      this.addFormData.leave_user_ids = []
      this.addFormData.work_shift_id = ''
      this.editId = ''
      this.isSelectShow = false
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.getRulesList()
    this.getMounthList()
  },
}
</script>
<style lang="less" scoped>
.punch {
  height: 100%;
  // 搜索行
  .searchRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .tableSearch {
      /deep/.el-input__inner {
        padding-left: 25px;
        height: 45px;
        border-radius: 24px;
        font-size: 16px;
        border: none;
        background-color: #f4f5f6;
        color: #333;
        &::placeholder {
          color: #333;
        }

        &::-webkit-input-placeholder {
          /* WebKit browsers 适配谷歌 */
          color: #333;
        }

        &:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 适配火狐 */
          color: #333;
        }
      }
    }
    .btnCol {
      display: flex;
      align-items: center;
      /deep/.el-button {
        font-size: 18px;
        font-weight: normal;
        border: none;
        width: 130px;
        height: 45px;
        background: #f4a029;
        color: #fff;
        border-radius: 24px;
        padding: 0;
        margin-left: 30px;
      }
      .out {
        background: #0099ff;
      }
    }
  }
  /deep/.el-table__header {
    box-sizing: border-box;
    th {
      border-color: #40a0f2 !important;
    }
    .gutter {
      background-color: #40a0f2;
    }
  }
  // 分页行
  .pageRow {
    box-sizing: border-box;
    padding-top: 10px;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    /deep/.el-pagination .el-select .el-input .el-input__inner {
      font-size: 14px;
      color: #333;
    }
    /deep/.el-pagination button,
    /deep/.el-pagination span:not([class*='suffix']) {
      font-size: 14px;
    }
  }
  // 表格行
  /deep/.el-table__body {
    width: 100% !important;
  }
  .el-table::before {
    display: none;
  }
  /deep/.el-table__body-wrapper {
    box-sizing: border-box;
    border: 1px solid #f4f5f6;
  }
  // 鼠标经过效果
  /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #eff8ff;
  }
  // 斑马颜色
  /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: #f4f5f6;
  }
  // 滚动条的宽度
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    // position: absolute;
    // bottom: 0;
    width: 6px; // 横向滚动条
    height: 5px; // 纵向滚动条 必写
  }
  // 滚动条的滑块
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #ddd;
    border-radius: 3px;
  }
  // 滚动条的滑块
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
    background-color: #ccc;
  }
  // *修改tabs样式
  /deep/.el-tabs__active-bar {
    width: 60px !important;
    margin-left: 30px;
  }
  /deep/.el-tabs {
    width: 100%;
    height: 100%;
    .el-tabs__header {
      width: 100%;
      margin-bottom: 20px;
      .el-tabs__nav-wrap {
        width: 100%;
        .el-tabs__nav-scroll {
          width: 100%;
          .el-tabs__nav {
            box-sizing: border-box;
            padding-left: 20px;
            width: 100%;
          }
        }
      }
    }
    .el-tabs__content {
      height: calc(100% - 80px);
      .el-tab-pane {
        height: 100%;
      }
    }
  }
  /deep/.el-tabs__item {
    height: 60px;
    text-align: center;
    font-size: 20px;
    color: #999999;
    font-weight: 400;
    padding-right: 100px;
    // width: 17%;
  }
  /deep/.el-tabs__item.is-active {
    color: #333 !important;
  }
  /deep/.el-tabs__item:hover {
    color: #333 !important;
  }
  /deep/.el-tabs__nav-wrap::after {
    color: #999999;
  }
  // 修改tabs样式

  // 表格操作按钮
  .tableBtn {
    padding: 0;
    // display: flex;
    justify-content: center;
    width: 80px;
    height: 32px;
    border-color: #40a0f2;
    color: #0099ff;
    border-radius: 5px;
    font-weight: normal;
  }
  // dialog弹窗
  /deep/.el-dialog {
    border-radius: 10px;
    .el-dialog__header {
      border-radius: 10px 10px 0 0;
      background-color: #f4f5f6;
      font-size: 20px;
      color: #333;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 40px;
    }
  }
  // 修改dia尾部按钮样式
  .dialog-footer {
    width: 100%;
    display: flex;
    padding-left: 30%;
    .el-button {
      // width: 180px;
      width: 23%;
      height: 50px;
      padding: 0;
      font-size: 20px;
      font-weight: normal;
      color: #fff;
      border: none;
      border-radius: 25px;
      background-color: #40a0f2;
      margin-top: 40px;
    }
    .el-button:first-child {
      margin-right: 5%;
    }
  }
  /deep/.el-form-item {
    margin-bottom: 15px;
  }
  // 修改表单label
  /deep/.el-form-item__label {
    font-size: 16px;
    color: #333;
    box-sizing: border-box;
    padding-right: 40px;
    line-height: 40px;
  }
  // 修改内容
  /deep/.el-form-item__content {
    // display: flex;
    /deep/.el-select {
      width: 100%;
      .el-input {
        width: 100%;
      }
      .el-input__inner {
        width: 100%;
        font-size: 18px;
        color: #333 !important;
      }
    }
    .el-input__inner {
      // font-size: 14px;
      font-size: inherit;
      width: 100%;
      height: 40px;
      border-radius: 0;
      color: #333 !important;
    }
    .el-textarea {
      width: 100%;
      .el-textarea__inner {
        height: 70px;
        // font-size: 14px;
        font-size: inherit;
        resize: none;
        border-radius: 0;
        font-family: Microsoft YaHei;
      }
    }
    .el-radio-group {
      height: 35px;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .el-radio {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        // margin-right: 15%;
        width: 25%;
      }
      .el-radio__input {
        width: 16px;
        height: 16px;
        .el-radio__inner {
          width: 18px;
          height: 18px;
        }
      }
      .el-radio__label {
        font-size: 14px;
        padding-left: 5px;
      }
    }
  }

  .currentnumber {
    cursor: pointer;
  }
  .currentnumber:hover {
    color: #0099ff;
  }
  // 修改下啦
  /deep/.classChargePeople {
    width: 160px !important;
    min-width: 160px !important;
    margin-left: 18%;
  }
  /deep/.heder40 {
    height: 56px;
  }
}
/deep/.ql-container {
  font-size: inherit;
}
.yauto {
  height: 40vh;
  overflow-y: auto;
}
.yauto::-webkit-scrollbar {
  width: 5px !important;
}
.yauto::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.yauto::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
/deep/.filter-checked-app {
  box-sizing: border-box;
  height: 100%;
  line-height: 100%;
  .checked-app-item {
    box-sizing: border-box;
    height: 100%;
    display: flex;
    align-items: center;
  }
}
// 修改人员选择(搜索栏的人员选择)
/deep/#MyTransfer {
  width: 20%;
  .filter-dash-btn {
    border: 1px solid #dcdfe6 !important;
    border-radius: 0 !important;
    background-color: #fff !important;
    height: 40px !important;
    font-size: 14px;
  }
  .checked-app-item {
    margin-left: 5px !important;
    border: none;
    background-color: #fff !important;
    span {
      font-size: 14px !important;
    }
  }
}
/deep/.checkDia {
  .el-dialog__body {
    width: 100%;
    box-sizing: border-box;
    padding: 40px 6%;
  }
}
/deep/#MyTransfer {
  .filter-dash-btn {
    width: 100%;

    .filter-tips-default {
      width: 100%;
      padding-left: 25px;
    }
  }
}
// 去掉日期选择器图标
/deep/ .el-input__prefix {
  .el-icon-date {
    display: none;
  }
}
</style>
